import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[laToggleListItemTitle]',
  standalone: true,
})
export class ToggleListItemTitleDirective {
  constructor(public templateRef: TemplateRef<ToggleListItemTitleDirective>) {}
}
